  <div class="post-type-speciality custom-theme-modal modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
    role="document">
    <div class="modal-content modal-scrollable-content">
      <div class="modal-header d-block py-3 border-bottom">
        <div class="row">
          <div class="col-6 pr-0 d-flex align-items-center">
            <h6 class="heading-4">
              <span class="cursor-pointer mr-2" (click)="nextPostScreen.emit(0)">
                <img class="pb-1" src="assets/themes/icons/grey-arrow.svg" alt="back">
              </span>
              <span class="color-grey-700">
              {{mls.languageText.create_post_type.key1}}
              <span *ngIf="mls?.is_lskey_display==1">(create_post_type.key1)</span></span>
            </h6>
            
          </div>

          <div class="col-6 text-right">
            <button [disabled]="showColor==false" [ngClass]=" showColor ? 'filled' : 'filled-disabled'"
              (click)="callNextScreen()" [appAnalyticsEvent]="analyticsDataCaseTypeNext" type="button"
              class="btn-design medium w-25">
              {{mls.languageText.create_post_type.key2}}
              <span *ngIf="mls?.is_lskey_display==1">(create_post_type.key2)</span>
            </button>
          </div>
        </div>
        <label class="secondary-paragraph pl-3" *ngIf="err_msg">
          <span class="color-error">
            {{err_msg}}
          </span>
        </label>
      </div>
      <div *ngIf="dss?.posting_data?.screen1?.feed_kind!='poll' && dss.isRepostStatus !== repostStatus.TWO" class="py-2 mb-1">
        <label class="pl-4 switch checkbox switch-position-right" >
          <input input type="checkbox"  [appAnalyticsEvent]="analyticsDataCaseToggle"
            [checked]="dss?.posting_data?.screen1?.feed_kind=='cases'" (change)="changeFeedKind($event)"/>
          <span>
            {{mls.languageText.create_post_type.key3}}
            <span *ngIf="mls?.is_lskey_display==1">(create_post_type.key3)</span>
          </span>
        </label>
      </div>

      <div class="modal-body p-0 post-type-height">
        <!--Loaders-->
        <div *ngIf="dss.speciality_list?.length==0 && api_in_process==true" class='text-center'>
          <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
        </div>
        <!--EOf Loaders-->

        <div class="row m-0">
          <div class="col-md-7 px-4" *ngIf="dss.speciality_list!=null && dss.speciality_list?.length>0">
            <div class="post-type-card">
              <div class="px-3 pt-3 d-block rounded-0">
                <h4 class="heading-4 mb-2">
                  <span class="color-grey-700">{{mls.languageText.create_post_type.key4}}
                  <span *ngIf="mls?.is_lskey_display==1">(create_post_type.key4)</span></span>
                </h4>
                <div class="custom-dropdown mb-2">
                  <div>
                    <span class="icon-left">
                      <img class="mr-3" src="assets/themes/icons/search-icon.svg" alt="search">
                    </span>
                    <span class="icon-right" *ngIf="userFilter.speciality_name!=''" (click)="resetSearchBox()">
                     <img src="assets/themes/icons/cancel.svg" width="16" alt="close" />
                    </span>
                    <input [(ngModel)]="userFilter.speciality_name" placeholder="{{mls.languageText.create_post_type.key5}}" />
                  </div>
                </div>
              </div>

              <div class="ps px-3 pt-2 position-relative post-type-speciality-height" [perfectScrollbar]="config">
                <!--  new design -->
                <div *ngIf="loading_data_in_process==true" class='text-center w-100'>
                  <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
                </div>
                <!-- list -->
                <div *ngFor="let speData of dss.speciality_list  | filterBy: userFilter">
                  <label class="list-item w-100 checkbox" id="SpecialityListItemPost">
                    <input type="checkbox" value="{{speData?.speciality_id}}"
                    [checked]="isSpecialitySelected(speData)" (click)="addSpeciality($event,speData)" id="specilaitInputChekBoxPost"/>
                    <span id="specilaitInputSpanPost">
                      <div class="d-none float-left rounded mr-2">
                        <img alt="specialty logo" [src]="speData?.logo"
                          onerror="this.src='assets/themes/icons/banner-placeholder.svg'">
                      </div>
                      <div>
                        <p class="secondary-paragraph">
                          {{speData?.speciality_name}}
                        </p>
                      </div>
                    </span>
                  </label>
                </div>

                <div class="mt-2 mb-3 mr-2 ml-2 text-center paragraph-bold"
                  *ngIf="(dss.speciality_list  | filterBy: userFilter)?.length == 0 ">
                  <img class="ml-3" src="assets/themes/icons/no-search-result.svg" alt="no-result" /><br>
                  <span class="color-grey-500 pt-2">{{mls.languageText.create_post_type.key6}}</span><span
                    *ngIf="mls?.is_lskey_display==1">(create_post_type.key6)</span>
                </div>

                <!--end list-->
              </div>
            </div>
          </div>

          <div class="col-md-5 d-none d-md-block pb-3 pl-0"
            *ngIf="dss.posting_data.screen2.selected_speciality?.length>0 && dss.speciality_list?.length>0">
            <p class="mb-2 heading-4">
                {{mls.languageText.create_post_type.key4}}
                <span *ngIf="mls?.is_lskey_display==1">(create_post_type.key4)</span>
            </p>
            <div *ngFor="let selectedSpe of dss.posting_data.screen2.selected_speciality">
              <span class="chip large filled icon-position-right mb-2 h-auto"  id="selectedSpecialityPost">
                <img 
                 src="assets/themes/icons/cancel-white.svg" alt="Lock Icon" class="cursor-pointer" (click)="removeSpeciality(selectedSpe)">
                {{selectedSpe?.speciality_name}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block d-md-none modal-footer p-2 border-top">
        <p class="clearfix">
          <span class="chip h-auto large filled icon-position-right mb-2 ml-2" *ngFor="let selectedSpe of dss.posting_data.screen2.selected_speciality">
            <img src="assets/themes/icons/cancel-white.svg" 
              alt="Lock Icon" 
              class="cursor-pointer" 
              (click)="removeSpeciality(selectedSpe)">
            {{selectedSpe?.speciality_name}}
          </span>
        </p>
      </div>
    </div>
  </div>